import HomePage from '@/app/features/ams/pages/HomePage.vue';
import ClientPage from '@/app/features/ams/pages/ClientPage.vue';
import AttributesPage from '@/app/features/ams/pages/AttributesPage.vue';
import SystemsPage from '@/app/features/ams/pages/SystemsPage.vue';
import FiltersPage from '@/app/features/ams/pages/FiltersPage.vue';
import ToolsPage from '@/app/features/ams/pages/ToolsPage.vue';
import ExportPage from '@/app/features/ams/tools/export/Export.vue';
import ImportPage from '@/app/features/ams/tools/import/Import.vue';
import MdsPage from '@/app/features/ams/tools/mds/Mds.vue';
import ReportsPage from '@/app/features/ams/tools/reports/Reports.vue';
import {
  RouteRecordRaw,
  RouteLocationNormalized,
  NavigationGuardNext,
} from 'vue-router';
import { checkClientId } from '@/app/utils/route-utils';
import AccessGuard from '@/app/shared/guards/access-guard';
import { AMSSubjects } from '@/app/shared/services/ability-service';

let amsMountPath = '/ams';

const createAccessGuard =
  (accessKey: AMSSubjects) =>
  (
    _to: RouteLocationNormalized,
    _from: RouteLocationNormalized,
    next: NavigationGuardNext
  ) => {
    if (AccessGuard.hasAccess(accessKey)) {
      next();
    } else {
      next({ name: 'ams-home' });
    }
  };

const amsRoutes = [
  {
    path: `${amsMountPath}/home`,
    name: 'ams-home',
    component: HomePage,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: `${amsMountPath}/client`,
    name: 'ams-client',
    component: ClientPage,
    beforeEnter: checkClientId,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: `${amsMountPath}/attributes`,
    name: 'ams-attributes',
    component: AttributesPage,
    beforeEnter: checkClientId,
    props: (route: any) => ({
      attributeName: route.query.attributeName,
      attributeId: route.query.attributeId,
    }),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: `${amsMountPath}/systems`,
    name: 'ams-systems',
    component: SystemsPage,
    beforeEnter: checkClientId,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: `${amsMountPath}/filters`,
    name: 'ams-filters',
    component: FiltersPage,
    beforeEnter: checkClientId,
    props: true,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: `${amsMountPath}/tools`,
    name: 'ams-tools',
    component: ToolsPage,
    beforeEnter: checkClientId,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: `${amsMountPath}/tools/export`,
    name: 'ams-export',
    component: ExportPage,
    beforeEnter: [checkClientId, createAccessGuard('EXPORT')],
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: `${amsMountPath}/tools/import`,
    name: 'ams-import',
    component: ImportPage,
    beforeEnter: [checkClientId, createAccessGuard('IMPORT')],
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: `${amsMountPath}/tools/mds`,
    name: 'ams-mds',
    component: MdsPage,
    beforeEnter: checkClientId,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: `${amsMountPath}/tools/reports`,
    name: 'ams-reports',
    component: ReportsPage,
    beforeEnter: checkClientId,
    meta: {
      requiresAuth: true,
    },
  },
];

const getAmsRoutes = (path = '/ams'): Array<RouteRecordRaw> => {
  amsMountPath = path;
  return amsRoutes;
};

export { getAmsRoutes };
